import { useCallback, createContext, useState, useEffect } from 'react';
import { remoteConfig, fetchFlags } from 'libs/flags';

export const FlagsContext = createContext();
// it can cause error indexedDB is not defined in the unit test, so add async await to the function
// WIP fix unit test, revert the remote config line

const FlagsProvider = ({ defaults, children }) => {
  const [flags, setFlags] = useState(defaults);

  // Get all remote flags
  useEffect(() => {
    remoteConfig().defaultConfig = defaults;
  }, [defaults]);

  if (process.env.NODE_ENV === 'development') {
    remoteConfig().settings = {
      minimumFetchIntervalMillis: 3600000
    };
  }

  // Get all remote flags
  const handleRemoteConfig = useCallback(async () => {
    const newFlags = await fetchFlags();
    setFlags((currentFlags) => ({ ...currentFlags, ...newFlags }));
  }, [remoteConfig]);

  useEffect(() => {
    handleRemoteConfig();
  }, [handleRemoteConfig]);

  return (
    <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>
  );
};

export default FlagsProvider;
